import React from 'react'
import { Text } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/Icon'
import type { TableRowData } from '@ui-kit/components/Table/types'
import Box from '@ui-kit/components/layoutComponents/Box/index.native'
import { body2 } from '@ui-kit/core/typography'

interface Props {
  rowContentValue: TableRowData
  isDescriptionExpanded: boolean
}

const TableRowContentValue = (props: Props) => {
  const renderValue = () => {
    switch (props.rowContentValue.type) {
      case 'boolean':
        return (
          <Icon
            imgSrc={
              props.rowContentValue.value === 'true'
                ? IMAGE.icons.small.checkBoxSmallGreen_24
                : IMAGE.icons.small.crossSmallRed_24
            }
          />
        )
      case 'string':
        return (
          <Text className={body2({ bold: props.isDescriptionExpanded })}>
            {props.rowContentValue.value}
          </Text>
        )
      default:
        throw new Error(`Assertion: can't render "${props.rowContentValue.type}" type of value`)
    }
  }

  return (
    <Box flex={1} alignItems="center" alignSelf="flex-start">
      {renderValue()}
    </Box>
  )
}

export default TableRowContentValue
